// extracted by mini-css-extract-plugin
export default {"content":"GxiqigNUH3TmrBwl1JyH"};